import cloneDeep from 'lodash/cloneDeep';
import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { TABS } from 'constants/tabs';
import { TRAIL_URL } from 'constants/config';
import { DAY_RANGE } from '__mocks__/AllStock';

// import { email } from '__mocks__/email';

const initialState = {
  isLoading: false, /** 備用 */
  dialog: null,
  currentTab: TABS.ALL_STOCK /** 所有個股 || 自選策略 */,

  currentStock: null /** 個股資訊 > 代號 */,
  currentStrategy: null /** 個股資訊 > 策略 */,
  currentLongShort: 1 /** 個股資訊 > 多空; 多空 = 0 多 = 1 空 = 2 */,
  currentSeriesIndex: 0, // 當前股票的index
  dayRange: DAY_RANGE[0].value,

  /** 登入狀態, TODO: 整合登入狀態 */
  isTrail: false,
  isLogin: false,
  currentEmail: '' /** 登入者的email */,

  /** 策略清單 */
  strategyList: [],
  /** 所有股票代號 */
  BQMarketName: [],
  /** 當前股票 股票策略資料 */
  dynamicProfitOrderby: [],
  /** 股票chart資料 開盤價 收盤價那些 */
  UserAiSMProfit: [],
  /** 自選策略清單 */
  UserMarketProfile: [],
};

const store = (set) => ({
  ...cloneDeep(initialState),
  login: (currentEmail) =>
    set(() => ({
      isLogin: true,
      currentEmail,
    })),

  /** 試用 
  trailLogin: () =>
    set(() => ({
      isTrail: true,
      isLogin: true,
      currentEmail: email /** 先使用測試mail登入 ,
    })),
  */
  trailLogin: () => {
    window.open(TRAIL_URL);
  },

  logout: () =>
    set(() => ({
      isTrail: false,
      isLogin: false,
      currentEmail: '',
      currentTab: TABS.ALL_STOCK /** 跳回所有個股 */,
    })),
  openDialog: (payload) => set(() => ({ dialog: payload })),
  closeDialog: () => set(() => ({ dialog: null })),
  setCurrentStock: (payload) => set(() => ({ currentStock: payload })),
  setCurrentStrategy: (payload) => set(() => ({ currentStrategy: payload })),
  setCurrentLongShort: (payload) => set(() => ({ currentLongShort: payload })),
  setBQMarketName: (payload) => set(() => ({ BQMarketName: payload })),
  setStrategyList: (payload) => set(() => ({ strategyList: payload })),
  setDynamicProfitOrderby: (payload) => set(() => ({ dynamicProfitOrderby: payload })),
  setUserMarketProfile: (payload) => set(() => ({ UserMarketProfile: payload })),
  setUserAiSMProfit: (payload) => set(() => ({ UserAiSMProfit: payload })),
  setCurrentTab: (payload) => set(() => ({ currentTab: payload })),
  setCurrentSeriesIndex: (payload) =>
    set(({ currentSeriesIndex }) => {
      if (!payload || currentSeriesIndex === payload) {
        return;
      }
      return { currentSeriesIndex: payload };
    }),
  setDayRange: (payload) => set(() => ({ dayRange: payload })),
  minusDayRange: () =>
    set(({ dayRange }) => {
      if (dayRange === 0) {
        return { dayRange: 0 };
      }
      return { dayRange: dayRange + 10 };
    }),
  increaseDayRange: () =>
    set(({ dayRange }) => {
      if (dayRange === 0) {
        return { dayRange: 0 };
      }
      if (dayRange <= 10) {
        return { dayRange };
      }
      return { dayRange: dayRange - 10 };
    }),
});

export const useStore = create(devtools(store));
